import { AppStateStatus } from 'react-native';

import { ICurrentUserStatus } from '@didomi/react';
import { CurrentUserStatus } from '@didomi/react-native';

import {
    GET_CONSENT_ORDERING,
    GET_LANGUAGES,
    GET_LANGUAGES_FAILURE,
    GET_LANGUAGES_REQUEST,
    GET_LANGUAGES_SUCCESS,
    SET_APP_STATE,
    SET_CONSENT_ORDERING,
    SET_DIDOMI_USER_STATUS,
    SET_INITIAL_WEB_PATHNAME,
    SET_REDUCE_MOTION_ENABLED,
    SET_SCREEN_READER_ENABLED,
    SET_SPLASH_SCREEN_STATE,
} from './constants';
import { ConfigState, InitialWebPathParams } from './reducer.types';

export function getLanguages(
    payload: {
        languages: Partial<ConfigState['app']['languages']>;
    },
    meta?: { onRequestEnd?: () => void },
) {
    return { type: GET_LANGUAGES, payload, meta };
}

export function getLanguagesRequest() {
    return { type: GET_LANGUAGES_REQUEST };
}

export function getLanguagesSuccess() {
    return {
        type: GET_LANGUAGES_SUCCESS,
    };
}

export function getLanguagesFailure(error: any) {
    return { type: GET_LANGUAGES_FAILURE, payload: { error } };
}

export function setAppState(appState: AppStateStatus) {
    return {
        type: SET_APP_STATE,
        payload: { appState },
    };
}

export function setInitialWebPathName(
    initialWebPathParams: InitialWebPathParams,
) {
    return {
        type: SET_INITIAL_WEB_PATHNAME,
        payload: { initialWebPathParams },
    };
}

export function setReduceMotionEnabled(reduceMotionEnabled: boolean) {
    return {
        type: SET_REDUCE_MOTION_ENABLED,
        payload: { reduceMotionEnabled },
    };
}

export function setScreenReaderEnabled(screenReaderEnabled: boolean) {
    return {
        type: SET_SCREEN_READER_ENABLED,
        payload: { screenReaderEnabled },
    };
}

export function getConsentOrdering() {
    return { type: GET_CONSENT_ORDERING };
}

export function setConsentOrdering(payload: {
    consentOrdering: string[] | undefined;
}) {
    return { type: SET_CONSENT_ORDERING, payload };
}

export function setDidomiUserStatus(
    didomiUserStatus: CurrentUserStatus | ICurrentUserStatus,
) {
    return {
        type: SET_DIDOMI_USER_STATUS,
        payload: { didomiUserStatus },
    };
}

export function setSplashScreenState(
    payload: Partial<ConfigState['splashScreen']>,
) {
    return { type: SET_SPLASH_SCREEN_STATE, payload };
}
